import { render, staticRenderFns } from "./RequestsTable.vue?vue&type=template&id=1bf05099"
import script from "./RequestsTable.vue?vue&type=script&lang=ts"
export * from "./RequestsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports